<ion-grid>
  <ion-row>
    <ion-col size="3">



      <ion-card style="height: 100%" *ngIf="sajatIntezmeny">
        <ion-card-header>
          <ion-card-title><span style="vertical-align: -webkit-baseline-middle;">Szűrő</span>
          </ion-card-title>
        </ion-card-header>
        <ion-card-content
          style="padding-top:10px !important; padding-left:10px !important; padding-right:10px !important; padding-bottom: 0 !important;">
          <ng-container>

            <ion-input label="Név" label-placement="stacked" fill="outline" placeholder=""
              [(ngModel)]="szuro.nev" (keyup.enter)="szures()" (ionInput)="szures()"></ion-input><br>
            <ion-input label="Oktatási azonosító" label-placement="stacked" fill="outline"
              placeholder="" [(ngModel)]="szuro.oktazon" (keyup.enter)="szures()" (ionInput)="szures()"></ion-input><br>
            <ion-input label="Felhasználónév" label-placement="stacked" fill="outline" placeholder=""
              [(ngModel)]="szuro.adid" (keyup.enter)="szures()" (ionInput)="szures()"></ion-input>
            <ion-grid>
              <ion-row>
                <ion-col size="6">
                  <ion-button color="primary" expand="block" (click)="szures()">
                    <ion-icon slot="start" name="search"></ion-icon>
                    Keresés
                  </ion-button>
                </ion-col>
                <ion-col size="6">
                  <ion-button color="dark" expand="block" (click)="szuresTorles()">
                    <ion-icon slot="start" name="close"></ion-icon>
                    Törlés
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>

          </ng-container>
        </ion-card-content>
      </ion-card>



    </ion-col>
    <ion-col size="9">

      <div style="margin-top: 10px;">
        <ion-button color="primary" (click)="ujTanulo()">
          <ion-icon slot="start" name="add"></ion-icon>
          Új
        </ion-button>
        <ion-button color="secondary" [disabled]="selected.length!=1" (click)="initModal(selected[0].oktazon)">
          <ion-icon slot="start" name="create"></ion-icon>
          Módosítás
        </ion-button>
        <ion-button color="danger" [disabled]="selected.length==0" (click)="kijeloltekTorlese()">
          <ion-icon slot="start" name="trash"></ion-icon>
          Törlés ({{selected.length}})
        </ion-button>
        <span style="margin-left:10px;color:#666">{{ allomany?.length || 0 }} tanuló</span>
        <ion-select style="display:inline-block;min-width:130px;margin-left:10px" interface="popover"
                    label="Sor/oldal" labelPlacement="stacked" [(ngModel)]="lapMeret">
          <ion-select-option [value]="10">10</ion-select-option>
          <ion-select-option [value]="25">25</ion-select-option>
          <ion-select-option [value]="50">50</ion-select-option>
          <ion-select-option [value]="100">100</ion-select-option>
        </ion-select>
      </div>
      <ng-container>
        <!-- Lapozó: a lista több száz tanuló is lehet, a footer nélkül csak az első
             10 sor látszott, és nem lehetett tovább lépni. -->
        <ngx-datatable #tanuloTable (select)="onSelect($event)"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
          [rows]="allomany" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [limit]="lapMeret"
          [footerHeight]="50"
          [count]="allomany?.length || 0"
          [selected]="selected" [selectionType]="SelectionType.checkbox" [rowClass]="getRowClass" [sorts]="[
  { prop: 'created_at', dir: 'desc' },
  { prop: 'updated_at', dir: 'desc' },
  { prop: 'priority', dir: 'desc' },
  { prop: 'deadline', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false"
            [resizeable]="false">
            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn">
              <input type="checkbox" [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)" />
            </ng-template>
            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn">
              <input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Név" prop="created_at">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Név</b>
              <app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="row.oktazon" [nev]="row.viselt_vez + ' ' + row.viselt_ker"></app-profilkep>
              {{ row.viselt_vez }} {{ row.viselt_ker }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Születési hely" prop="szul_hely">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <b class="mobil">Születési hely</b>
              {{ value }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Oktatási azonosító" prop="oktazon">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Oktatási azonosító</b>
              <span *ngIf="value">{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Felhasználónév" prop="adid">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Felhasználónév</b>
              {{ value }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Műveletek</b>
              <ion-button color="secondary" size="small" style="margin-top:0" title="Módosítás"
                (click)="initModal(row.oktazon)">
                <ion-icon slot="icon-only" name="create"></ion-icon>

              </ion-button>
              <ion-button color="danger" size="small" style="margin-top:0" title="Törlés"
                (click)="tanuloTorol(row)">
                <ion-icon slot="icon-only" name="trash"></ion-icon>

              </ion-button>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>



    </ion-col>
  </ion-row>
</ion-grid>









<ion-modal class="nagy" style="z-index: 1000" #uzenetmodal trigger="uzenet">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>Tanuló</ion-title>
        <ion-buttons slot="end">
          <ion-button style="background: white; border-radius: 5px" (click)="confirm(1)" [strong]="true" shape="round"
            color="secondary">Mentés</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">

      <ion-segment value="1" color="primary" [scrollable]="true" [(ngModel)]="segment" (ngModelChange)="segmentValt($event)">
        <ion-segment-button value="1" layout="icon-start">
          <ion-label>Személyes</ion-label>
          <ion-icon name="person"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="2" layout="icon-start">
          <ion-label>Cím és elérhetőség</ion-label>
          <ion-icon name="call"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="3" layout="icon-start">
          <ion-label>Tanügy</ion-label>
          <ion-icon name="briefcase"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="4" layout="icon-start">
          <ion-label>Belépés</ion-label>
          <ion-icon name="log-in"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="5" layout="icon-start">
          <ion-label>SNI / BTMN</ion-label>
          <ion-icon name="medkit"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="6" layout="icon-start" *ngIf="aktivTanulo?.oktazon">
          <ion-label>Ellenőrző</ion-label>
          <ion-icon name="reader"></ion-icon>
        </ion-segment-button>
      </ion-segment>
      <hr>

      <form [formGroup]="form">
        <ion-grid>
          <ion-row *ngIf="segment=='1'">
            <!--table style="width: 100%;">
      <thead>

      </thead>
      <tbody>
        <tr>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
        </tr>
        <tr>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
        </tr>
      </tbody>
    </table-->
            <ion-col>
              <ion-input label="Előtag{{ cs('viselt_elo') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="viselt_elo">
                <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
              </ion-input><br>
              <ion-input label="Születési előtag{{ cs('szul_elo') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="szul_elo">
                <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
              </ion-input><br>
              <ion-input label="Anyja leánykori előtag{{ cs('anya_elo') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="anya_elo">
                <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon></ion-input><br>
              <!--ion-input label="Születési hely" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="balloon" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Születési hely</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Születési hely</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="balloon" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="telepules" formControlName="szul_hely" itemValueField="id"
                      itemTextField="full_name_irsz" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="false"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <!--ion-input label="Anyanyelv" label-placement="stacked" fill="outline" placeholder=""><ion-icon slot="start"
                name="globe" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Anyanyelv</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Anyanyelv</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="globe" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="allampolgar" formControlName="anyanyelv" itemValueField="id"
                      itemTextField="nev" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="true"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <ion-input label="Oktatási azonosító{{ cs('oktazon') }}" label-placement="stacked" fill="outline" placeholder=""
                maxlength="11" formControlName="oktazon" minlength="11"><ion-icon slot="start" name="business"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <!-- A tanulói SAJÁT felület belépéséhez: a diák ugyanazon az IdP-n jön be, mint a
                   tanárok, ezért ide a Microsoft-fiók (iskolai e-mail) kerül. Ez köti össze a
                   belépő felhasználót a tanulói törzsadattal. -->
              <ion-input label="Belépési azonosító (Microsoft-fiók / e-mail){{ cs('adid') }}" label-placement="stacked" fill="outline"
                placeholder="diak.nev@iskola.hu" formControlName="adid"><ion-icon slot="start" name="key"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="E-mail cím{{ cs('email') }}" label-placement="stacked" fill="outline" type="email"
                placeholder="" formControlName="email"><ion-icon slot="start" name="mail"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Telefonszám{{ cs('telefon') }}" label-placement="stacked" fill="outline"
                placeholder="" formControlName="telefon"><ion-icon slot="start" name="call"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <!--ion-input label="Igazolvány típus" label-placement="stacked" fill="outline" placeholder=""></ion-input-->
              <ion-select aria-label="Igazolvány típus{{ cs('ig_tipus') }}" interface="popover" placeholder="" label="Igazolvány típus"
                label-placement="stacked" fill="outline" formControlName="ig_tipus">
                <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
                <ion-select-option value="Személyi igazolvány">Személyi igazolvány</ion-select-option>
                <ion-select-option value="Ideiglenes személyi igazolvány">Ideiglenes személyi
                  igazolvány</ion-select-option>
                <ion-select-option value="Jogosítvány">Jogosítvány</ion-select-option>
                <ion-select-option value="Útlevél">Útlevél</ion-select-option>
                <ion-select-option value="Tartózkodási / lakcímet igazoló engedély">Tartózkodási / lakcímet igazoló
                  engedély</ion-select-option>
              </ion-select>
            </ion-col>
            <ion-col>
              <ion-input label="Családi név{{ cs('viselt_vez') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="viselt_vez">
                <ion-icon slot="start" name="people" aria-hidden="true"></ion-icon>
              </ion-input><br>
              <ion-input label="Születési családi név{{ cs('szul_vez') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="szul_vez"><ion-icon slot="start" name="people"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Anyja családi név{{ cs('anya_vez') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="anya_vez"><ion-icon slot="start" name="people"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Születési idő{{ cs('szul_datum') }}" label-placement="stacked" fill="outline" placeholder="" type="date"
                max="3000-12-31" formControlName="szul_datum"><ion-icon slot="start" name="time"
                  aria-hidden="true"></ion-icon></ion-input><br>

              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  <ion-datetime style="border: 1px solid;" id="datetime" [firstDayOfWeek]="1" presentation="date"
                    [formatOptions]="{
                  date: {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                  },
                }"></ion-datetime>
                </ng-template>
              </ion-modal>
              <!--ion-input label="Állampolgárság" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="planet" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Állampolgárság</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Állampolgárság</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="planet" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="allampolgar" formControlName="allampolgar_1"
                      itemValueField="id" itemTextField="nev" [canSearch]="true" [canClear]="true"
                      closeButtonText="Mégse" [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'"
                      [hasInfiniteScroll]="true" clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <ion-select aria-label="Igazolvány típus{{ cs('nem') }}" interface="popover" placeholder="" label="Nem"
                formControlName="nem" label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="male-female" aria-hidden="true"></ion-icon>
                <ion-select-option value="1">Férfi</ion-select-option>
                <ion-select-option value="2">Nő</ion-select-option>
                <ion-select-option value="3">Egyéb</ion-select-option>
              </ion-select><br>
              <ion-input label="Igazolvány szám{{ cs('ig_szam') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="ig_szam"><ion-icon slot="start" name="id-card"
                  aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
            <ion-col>
              <ion-input label="Utónév{{ cs('viselt_ker') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="viselt_ker"><ion-icon slot="start" name="person"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Születési utónév{{ cs('szul_ker') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="szul_ker"><ion-icon slot="start" name="person"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Anyja utónév{{ cs('anya_ker') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="anya_ker"><ion-icon slot="start" name="person"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <!--ion-input label="Születési ország" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="earth" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Születési ország</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Születési ország</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="globe" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="orszag" formControlName="szul_orszag" itemValueField="id"
                      itemTextField="nev" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="true"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <!--ion-input label="Második állampolgárság" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="planet" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Második állampolgárság</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Második állampolgárság</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="planet" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="allampolgar" formControlName="allampolgar_2"
                      itemValueField="id" itemTextField="nev" [canSearch]="true" [canClear]="true"
                      closeButtonText="Mégse" [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'"
                      [hasInfiniteScroll]="true" clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <ion-input label="TAJ-szám{{ cs('taj') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="taj"><ion-icon slot="start" name="medical"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Adóazonosító jel{{ cs('adoazon') }}" label-placement="stacked" fill="outline" placeholder=""
                formControlName="adoazon"><ion-icon slot="start" name="briefcase"
                  aria-hidden="true"></ion-icon></ion-input>
              <!-- Igazolványok: a KRÉTÁ-ból jönnek (tanulói törzsadat-átvétel), itt csak látszanak. -->
              <div class="tan-igazolvanyok" *ngIf="vanIgazolvany">
                <h4>Igazolványok <small>(a KRÉTÁ-ból)</small></h4>
                <div *ngIf="igazolvanyok.diakszam">Diákigazolvány: <b>{{ igazolvanyok.diakszam }}</b>
                  <span *ngIf="igazolvanyok.diakigazolvany_kelte"> · kelte: {{ igazolvanyok.diakigazolvany_kelte }}</span></div>
                <div *ngIf="igazolvanyok.igazolvany_szam">{{ igazolvanyok.igazolvany_tipus || 'Igazolvány' }}: <b>{{ igazolvanyok.igazolvany_szam }}</b></div>
                <div *ngIf="igazolvanyok.meresi_azonosito">Mérési azonosító: <b>{{ igazolvanyok.meresi_azonosito }}</b></div>
              </div>
            </ion-col>
          </ion-row>



          <ion-row *ngIf="segment=='2'">

          </ion-row>
          <h1 *ngIf="segment=='2'">Állandó lakcím</h1>
          <ion-row *ngIf="segment=='2'">

            <ion-col>
              <ion-input label="Irányítószám{{ cs('all_cim_irsz') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="all_cim_irsz"
                type="number"><ion-icon slot="start" name="apps" aria-hidden="true"></ion-icon></ion-input>
            </ion-col><ion-col>
              <ion-input label="Település{{ cs('all_cim_telepules') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="all_cim_telepules"
                type="text"><ion-icon slot="start" name="home" aria-hidden="true"></ion-icon></ion-input>
            </ion-col><ion-col>
              <ion-input label="Köztér{{ cs('all_cim_kozter') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="all_cim_kozter"
                type="text"><ion-icon slot="start" name="bookmark" aria-hidden="true"></ion-icon></ion-input>
            </ion-col><ion-col>
              <ion-input label="Köztér jellege{{ cs('all_cim_kozter_jelleg') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="all_cim_kozter_jelleg"
                type="text"><ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon></ion-input>
            </ion-col><ion-col>
              <ion-input label="Házszám / Hrsz.{{ cs('all_cim_hsz') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="all_cim_hsz"
                type="text"><ion-icon slot="start" name="bed" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="segment=='2'">
            <ion-col>
              <ion-input label="Pontosítás (ép.,em.,aj.){{ cs('all_cim_pontos') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="all_cim_pontos"
                type="text"><ion-icon slot="start" name="business" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
          <h1 *ngIf="segment=='2'">Tartózkodási cím</h1>
          <ion-row *ngIf="segment=='2'">

            <ion-col>
              <ion-input label="Irányítószám{{ cs('tart_cim_irsz') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="tart_cim_irsz"
                type="number"><ion-icon slot="start" name="apps" aria-hidden="true"></ion-icon></ion-input>
            </ion-col><ion-col>
              <ion-input label="Település{{ cs('tart_cim_telepules') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="tart_cim_telepules"
                type="text"><ion-icon slot="start" name="home" aria-hidden="true"></ion-icon></ion-input>
            </ion-col><ion-col>
              <ion-input label="Köztér{{ cs('tart_cim_kozter') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="tart_cim_kozter"
                type="text"><ion-icon slot="start" name="bookmark" aria-hidden="true"></ion-icon></ion-input>
            </ion-col><ion-col>
              <ion-input label="Köztér jellege{{ cs('tart_cim_kozter_jelleg') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="tart_cim_kozter_jelleg"
                type="text"><ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon></ion-input>
            </ion-col><ion-col>
              <ion-input label="Házszám / Hrsz.{{ cs('tart_cim_hsz') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="tart_cim_hsz"
                type="text"><ion-icon slot="start" name="bed" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="segment=='2'">
            <ion-col>
              <ion-input label="Pontosítás (ép.,em.,aj.){{ cs('tart_cim_pontos') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="tart_cim_pontos"
                type="text"><ion-icon slot="start" name="business" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>


    

          <!--  TANÜGY: a tanuló valódi tanügyi adatai (jogviszony, csoportok, felmentések).
                Korábban itt egy helykitöltő táblázat állt, a dolgozói listára kötve. -->
          <ion-row *ngIf="segment=='3'">
            <ion-col size="12">
              <div *ngIf="tanugyFut" class="tanugy-ures"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
              <div *ngIf="tanugyHiba" class="tanugy-hiba">{{ tanugyHiba }}</div>
              <ng-container *ngIf="tanugy && !tanugyFut">
                <h3 class="tanugy-cim">Jogviszony</h3>
                <div *ngIf="!tanugy.jogviszony?.length" class="tanugy-ures">Nincs rögzített jogviszony.</div>
                <table class="tanugy-tabla" *ngIf="tanugy.jogviszony?.length">
                  <thead><tr><th>Osztály</th><th>Évf.</th><th>Kezdete</th><th>Vége</th><th>Várható vége</th><th>Napló-sorszám</th><th>Törzslapszám</th><th>Jelölések</th><th>Kilépés oka</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let j of tanugy.jogviszony" [class.lezart]="j.vege && j.vege !== '0000-00-00'">
                      <td data-cimke="Osztály"><b>{{ j.osztaly_nev || '–' }}</b></td>
                      <td data-cimke="Évf.">{{ j.evfolyam || '–' }}</td>
                      <td data-cimke="Kezdete">{{ j.kezdete || '–' }}</td>
                      <td data-cimke="Vége">{{ j.vege && j.vege !== '0000-00-00' ? j.vege : 'folyamatban' }}</td>
                      <td data-cimke="Várható vége">{{ j.varh_vege || '–' }}</td>
                      <td data-cimke="Napló-sorszám">{{ j.naplosorszam || '–' }}</td>
                      <td data-cimke="Törzslapszám">{{ j.torzslapszam || '–' }}</td>
                      <td data-cimke="Jelölések">
                        <ion-badge color="medium" *ngIf="+j.vendeg">vendég</ion-badge>
                        <ion-badge color="tertiary" *ngIf="+j.egyeni_tanrend" [title]="j.egyeni_tanrend_oka || ''">egyéni munkarend<ng-container *ngIf="j.egyeni_tanrend_kezdete || j.egyeni_tanrend_vege">: {{ j.egyeni_tanrend_kezdete || '…' }} – {{ j.egyeni_tanrend_vege || '…' }}</ng-container></ion-badge>
                        <ion-badge color="warning" *ngIf="+j.ideiglenes">ideiglenes</ion-badge>
                        <ion-badge color="danger" *ngIf="+j.statusz === 2">szünetel</ion-badge>
                        <span *ngIf="!+j.vendeg && !+j.egyeni_tanrend && !+j.ideiglenes">–</span>
                      </td>
                      <td data-cimke="Kilépés oka">{{ j.kilepes_ok_szoveg || j.kilepes_ok || '–' }}
                        <div *ngIf="j.atvevo_intezmeny"><small>Új intézmény: {{ j.atvevo_intezmeny }}</small></div>
                        <!-- Szüneteltetés: a tanuló nem jelenik meg a névsorokban, az adatai megmaradnak. -->
                        <div *ngIf="(+j.statusz === 1 || +j.statusz === 2) && !(j.vege && j.vege !== '0000-00-00')">
                          <ion-button size="small" fill="outline" [color]="+j.statusz === 2 ? 'success' : 'medium'" (click)="jogviszonySzunetel(j)">
                            {{ +j.statusz === 2 ? 'Szüneteltetés vége' : 'Szüneteltetés' }}
                          </ion-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h3 class="tanugy-cim">Csoportok</h3>
                <div *ngIf="!tanugy.csoportok?.length" class="tanugy-ures">Nincs csoporttagság.</div>
                <div class="tanugy-chipek" *ngIf="tanugy.csoportok?.length">
                  <span class="tanugy-chip" *ngFor="let c of tanugy.csoportok"
                        [class.lezart]="c.vege && c.vege !== '0000-00-00' && c.vege < ma"
                        [title]="(c.kezdete || '') + ' – ' + (c.vege && c.vege !== '0000-00-00' ? c.vege : '')">
                    {{ c.csoport }}<small *ngIf="c.vege && c.vege !== '0000-00-00' && c.vege < ma"> (kilépett {{ c.vege }})</small>
                  </span>
                </div>

                <h3 class="tanugy-cim">Felmentések</h3>
                <div *ngIf="!tanugy.felmentesek?.length" class="tanugy-ures">Nincs felmentés.</div>
                <table class="tanugy-tabla" *ngIf="tanugy.felmentesek?.length">
                  <thead><tr><th>Tantárgy</th><th>Időszak</th><th>Mi alól</th><th>Ok / határozat</th><th>Forrás</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let f of tanugy.felmentesek">
                      <td data-cimke="Tantárgy"><b>{{ f.tantargy_nev || '–' }}</b></td>
                      <td data-cimke="Időszak">{{ f.kezdete || '?' }} – {{ f.vege || 'visszavonásig' }}</td>
                      <td data-cimke="Mi alól">{{ felmentesMiAlol(f) }}</td>
                      <td data-cimke="Ok">{{ f.ok || '–' }}<div *ngIf="f.hatarozat"><small>{{ f.hatarozat }}</small></div></td>
                      <td data-cimke="Forrás">{{ f.forras }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="segment=='4'">
            <ion-col size="12">
              <!--  A BELÉPÉS ITT DŐL EL. Korábban ezen a fülön egy nem működő KAS-űrlap
                    állt: a mezők nem mentettek sehova, a „Jogkör" választó pedig az
                    ORSZÁGLISTÁRA volt kötve – jogkört tehát nem is lehetett választani. -->
              <app-belepes-fiok fajta="tanulo"
                                [azonosito]="aktivTanulo?.adid || aktivTanulo?.oktazon || ''"
                                [nev]="(aktivTanulo?.viselt_vez || '') + ' ' + (aktivTanulo?.viselt_ker || '')">
              </app-belepes-fiok>
            </ion-col>
          </ion-row>




          <ion-row *ngIf="segment=='5'">
            <ion-col size="6">
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

                    <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" formControlName="sni">
                      Sajátos nevelési igényű</ion-checkbox>
                  </div>
                </label>
              </div><br>
            </ion-col> <ion-col size="6">
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

                    <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" formControlName="btmn">
                      Beilleszkedési, tanulási és magatartási nehézséggel küzdő</ion-checkbox>
                  </div>
                </label>
              </div><br>
            </ion-col>
          </ion-row>
          <!--  SNI / BTMN RÉSZLETEK a KRÉTÁ-ból (szakvélemény, javaslat, felülvizsgálat).
                Korábban itt két helykitöltő táblázat állt. -->
          <ion-row *ngIf="segment=='5'">
            <ion-col size="12">
              <div *ngIf="tanugyFut" class="tanugy-ures"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
              <ng-container *ngIf="tanugy && !tanugyFut">
                <div *ngIf="!tanugy.sni_btmn" class="tanugy-ures">
                  A KRÉTA szerint a tanuló nem SNI-s és nem BTMN-es (vagy a KRÉTA-szinkron még nem futott le).
                  A jelölés a KRÉTA feljegyzés-szinkronjával frissül.
                </div>
                <ng-container *ngIf="tanugy.sni_btmn as sb">
                  <div class="tanugy-ures">A KRÉTA tanulói adatlapjáról · frissítve: {{ sb.frissitve }}</div>
                  <div class="sni-blokkok">
                    <ng-container *ngFor="let sz of ['Általános', 'SNI', 'BTMN']">
                      <div class="sni-blokk" *ngIf="sniSzakasz(sb, sz).length && (sz === 'Általános' || (sz === 'SNI' && sb.sni) || (sz === 'BTMN' && sb.btmn))">
                        <h3 class="tanugy-cim">{{ sz === 'Általános' ? 'Jelölés' : (sz === 'SNI' ? 'Sajátos nevelési igény' : 'Beilleszkedési, tanulási, magatartási nehézség') }}</h3>
                        <div class="sni-sor" *ngFor="let a of sniSzakasz(sb, sz)">
                          <span class="sni-cimke">{{ a.cimke }}</span>
                          <span class="sni-ertek">{{ a.ertek || '–' }}</span>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </ion-col>
          </ion-row>
          <!--  SZAKÉRTŐI VÉLEMÉNYEK – saját, strukturált nyilvántartás a beírási naplóhoz (20/2012. EMMI r.
                95. § (5)): kiállító bizottság neve, címe, a vélemény száma, kelte, a felülvizsgálatok és a
                következő kötelező felülvizsgálat. Tanulónként több sor (minden felülvizsgálat egy sor).
                A KRÉTA-adatból egy gombbal előtölthető; írni admin és a tanuló osztályfőnöke tud (az
                Osztályfőnök › SNI / BTMN nézetben is), törölni csak admin (a kiszolgáló ellenőrzi). -->
          <ion-row *ngIf="segment=='5'">
            <ion-col size="12">
              <h3 class="tanugy-cim">Szakértői vélemények (beírási napló, 95. § (5))</h3>
              <div *ngIf="szvFut" class="tanugy-ures"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
              <div *ngIf="!szvFut && !szvLista.length && !szvUrlap" class="tanugy-ures">
                Még nincs rögzített szakértői vélemény. A beírási napló addig a KRÉTA-adatot mutatja (ha van).
              </div>
              <table class="tanugy-tabla" *ngIf="szvLista.length">
                <thead><tr><th>Típus</th><th>Kiállító bizottság</th><th>Szám, kelt</th><th>Következő felülvizsgálat</th><th>Megnevezés, javaslat</th><th></th></tr></thead>
                <tbody>
                  <tr *ngFor="let v of szvLista">
                    <td data-cimke="Típus"><b>{{ v.tipus }}</b><div *ngIf="+v.felulvizsgalat"><small>felülvizsgálat</small></div><div *ngIf="v.forras === 'kreta'"><small>KRÉTA-ból átvéve</small></div></td>
                    <td data-cimke="Bizottság">{{ v.bizottsag_nev || '–' }}<div *ngIf="v.bizottsag_cim"><small>{{ v.bizottsag_cim }}</small></div></td>
                    <td data-cimke="Szám, kelt">{{ v.velemeny_szam || '–' }}<div><small>{{ v.kelt || '' }}</small></div></td>
                    <td data-cimke="Köv. felülvizsgálat">{{ v.kovetkezo_felulvizsgalat || v.ervenyesseg || '–' }}</td>
                    <td data-cimke="Megnevezés">{{ v.fogyatekossag || '–' }}<div *ngIf="v.javaslat"><small>{{ v.javaslat }}</small></div></td>
                    <td data-cimke="">
                      <ion-button *ngIf="szvJog.iras" size="small" fill="clear" (click)="szvSzerkeszt(v)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
                      <ion-button *ngIf="szvJog.torles" size="small" fill="clear" color="danger" (click)="szvTorol(v)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div *ngIf="!szvUrlap && szvJog.iras" class="szv-gombok">
                <ion-button size="small" fill="outline" (click)="szvUj()"><ion-icon slot="start" name="add-outline"></ion-icon>Új szakértői vélemény / felülvizsgálat</ion-button>
                <ion-button size="small" fill="outline" color="medium" *ngFor="let k of szvKreta" (click)="szvUj(k)">
                  <ion-icon slot="start" name="download-outline"></ion-icon>Átvétel a KRÉTA-adatból ({{ k.tipus }})
                </ion-button>
              </div>
              <div *ngIf="szvUrlap as u" class="szv-urlap">
                <ion-select label="Típus" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="u.tipus" [ngModelOptions]="{ standalone: true }">
                  <ion-select-option value="SNI">SNI – sajátos nevelési igény</ion-select-option>
                  <ion-select-option value="BTMN">BTMN – beilleszkedési, tanulási, magatartási nehézség</ion-select-option>
                </ion-select>
                <ion-checkbox labelPlacement="end" [(ngModel)]="u.felulvizsgalat" [ngModelOptions]="{ standalone: true }">Felülvizsgálat eredménye</ion-checkbox>
                <ion-input label="Kiállító szakértői bizottság neve" label-placement="stacked" fill="outline" maxlength="255" [(ngModel)]="u.bizottsag_nev" [ngModelOptions]="{ standalone: true }"></ion-input>
                <ion-input label="A bizottság címe" label-placement="stacked" fill="outline" maxlength="255" [(ngModel)]="u.bizottsag_cim" [ngModelOptions]="{ standalone: true }"></ion-input>
                <ion-input label="A vélemény száma" label-placement="stacked" fill="outline" maxlength="100" [(ngModel)]="u.velemeny_szam" [ngModelOptions]="{ standalone: true }"></ion-input>
                <ion-input label="Kiállításának kelte" label-placement="stacked" fill="outline" type="date" [(ngModel)]="u.kelt" [ngModelOptions]="{ standalone: true }"></ion-input>
                <ion-input label="Következő kötelező felülvizsgálat" label-placement="stacked" fill="outline" type="date" [(ngModel)]="u.kovetkezo_felulvizsgalat" [ngModelOptions]="{ standalone: true }"></ion-input>
                <ion-input label="Érvényesség (ha nincs felülvizsgálati dátum)" label-placement="stacked" fill="outline" maxlength="255"
                           placeholder="pl. a középfokú tanulmányok befejezéséig" [(ngModel)]="u.ervenyesseg" [ngModelOptions]="{ standalone: true }"></ion-input>
                <ion-input label="Megnevezés (fogyatékosság / nehézség)" label-placement="stacked" fill="outline" maxlength="255" [(ngModel)]="u.fogyatekossag" [ngModelOptions]="{ standalone: true }"></ion-input>
                <ion-textarea label="A bizottság javaslata (mentesítések, kedvezmények)" label-placement="stacked" fill="outline" [autoGrow]="true" rows="2" [(ngModel)]="u.javaslat" [ngModelOptions]="{ standalone: true }"></ion-textarea>
                <ion-textarea label="Megjegyzés" label-placement="stacked" fill="outline" [autoGrow]="true" rows="1" [(ngModel)]="u.megjegyzes" [ngModelOptions]="{ standalone: true }"></ion-textarea>
                <div class="szv-gombok">
                  <ion-button size="small" (click)="szvMent()" [disabled]="szvMentes">{{ szvMentes ? 'Mentés…' : 'Mentés' }}</ion-button>
                  <ion-button size="small" fill="clear" color="medium" (click)="szvUrlap = null">Mégse</ion-button>
                </div>
              </div>
            </ion-col>
          </ion-row>
          <!--  HÁTRÁNYOS HELYZET, GYERMEKVÉDELEM (HH, HHH, RGYK, elhelyezés, menekült…) – időszakosan, határozattal;
                a lemorzsolódási jelzés (229/2012. Korm. r. 44/J. §) és a KIR-STAT ebből számol. Admin írja (lemorzsolodas.js). -->
          <ion-row *ngIf="segment=='5' && aktivTanulo?.oktazon">
            <ion-col size="12">
              <app-tanulo-helyzet [oktazon]="aktivTanulo.oktazon" [intezmeny]="sajatIntezmeny?.intezmenyId"></app-tanulo-helyzet>
            </ion-col>
          </ion-row>






          
        </ion-grid>
      </form>

      <!--  ELLENŐRZŐ – a tanuló egy tanévének minden iskolai adata (tanulo-ellenorzo.component.ts).
            Csak a fül első megnyitásakor kerül a lapra (lusta betöltés), utána fülváltáskor csak
            elrejtjük, hogy visszalépve ne töltsön újra. Az űrlapon kívül áll: saját ngModel-jei vannak. -->
      <app-tanulo-ellenorzo *ngIf="ellenorzoNyitva && aktivTanulo?.oktazon" [hidden]="segment !== '6'"
        [oktazon]="aktivTanulo.oktazon" [intezmeny]="sajatIntezmeny?.intezmenyId"
        [nev]="((aktivTanulo.viselt_vez || '') + ' ' + (aktivTanulo.viselt_ker || '')).trim()"></app-tanulo-ellenorzo>

    </ion-content>
  </ng-template>
</ion-modal>